export const GET_POPULAR_HASHTAGS = 'GET_POPULAR_HASHTAGS'
export const WAIT_GET_POPULAR_HASHTAGS = 'WAIT_GET_POPULAR_HASHTAGS'
